import { getAxiosInstance } from '../../react/utils/networkUtil';
import { PaginationQuery, PaginationResult } from '../models/AppPagination';
import { AppSuccess } from '../models/AppSuccess';
import { Comment_Base } from '../models/Comment';

// #region get page
export type Comment_GetPage_RequestQuery = PaginationQuery & {
  projectId: number;
  showDeleted: boolean;
};
export const remote_getPage = async (
  request: Comment_GetPage_RequestQuery,
): Promise<PaginationResult<Comment_Base>> => {
  return (
    await getAxiosInstance().get(`/api/comment-ext`, {
      params: request,
    })
  ).data;
};
// #endregion get page

// #region add
export type Comment_AddComment_RequestBody = {
  projectId: number;
  title: string;
  description: string;
  geojson?: string;
};
export const remote_addComment = async (request: Comment_AddComment_RequestBody): Promise<AppSuccess<Comment_Base>> => {
  return (await getAxiosInstance().post(`/api/comment-ext`, request)).data;
};
// #endregion add

// #region update
export type Comment_UpdateComment_RequestBody = {
  title?: string;
  description?: string;
  geojson?: string;
  resolved?: boolean;
};
export const remote_updateComment = async (
  id: number,
  request: Comment_UpdateComment_RequestBody,
): Promise<AppSuccess<Comment_Base>> => {
  return (await getAxiosInstance().put(`/api/comment-ext/${id}`, request)).data;
};
// #endregion update

// #region delete
export const remote_deleteComment = async (id: number): Promise<AppSuccess<Comment_Base>> => {
  return (await getAxiosInstance().delete(`/api/comment-ext/${id}`)).data;
};
// #endregion delete

export const CommentAPIs = {
  remote_getPage,
  remote_addComment,
  remote_updateComment,
  remote_deleteComment,
};
